import * as THREE from 'three';
import images from './images';


const loader = new THREE.TextureLoader();
import vertex from '../shaders/vertex.glsl';
import fragment from '../shaders/fragment.glsl';

const texture = loader.load(images.me);
const texture2 = loader.load(images.me2);
const texture3 = loader.load(images.dev);
const texture4 = loader.load(images.NY);
const DEBUG_HOVER_IMAGE = false;

function lerp(start, end, t){
    return start * (1 - t) + end * t;
}

class shaded{
    constructor() {
        this.container = document.querySelector(".landing");
        this.inner = document.querySelector(".intro");
        this.links =[...document.querySelectorAll("#shadedimg")];

        this.hovered = false;
        this.targetX = 0;
        this.targetY = 0;
        this.targetAlpha = 0;
        
        this.scene = new THREE.Scene();
        this.perspective = 1000;
        this.sizes = new THREE.Vector2(0, 0);
        this.offset = new THREE.Vector2(0, 0);
        this.uniforms={
            uTexture: {value: texture4},
            uAlpha: {value: 0.0},
            uOffset: {value: new THREE.Vector2(0.0, 0.0)},
        };
        this.links.map((link, i)=>{
            link.addEventListener("mouseenter", ()=>{
                this.hovered = true;
                this.targetAlpha = 1.0;

                switch(i){
                    case 0:
                        this.uniforms.uTexture.value = texture;
                        break;
                    case 1:
                        this.uniforms.uTexture.value = texture2;
                        break;
                    case 2:
                        this.uniforms.uTexture.value = texture3;
                        break;
                    case 3:
                        this.uniforms.uTexture.value = texture4;
                        break;
                }

                if (DEBUG_HOVER_IMAGE) {
                    console.log('hover image enter', {
                        index: i,
                        alpha: this.uniforms.uAlpha.value,
                        texture: this.uniforms.uTexture.value?.source?.data?.currentSrc || this.uniforms.uTexture.value?.image?.currentSrc || this.uniforms.uTexture.value?.image?.src,
                    });
                }
            });
            link.addEventListener('mouseleave', ()=>{
                this.targetAlpha = 0.0;

                if (DEBUG_HOVER_IMAGE) {
                    console.log('hover image leave', {
                        index: i,
                        alpha: this.uniforms.uAlpha.value,
                    });
                }
            });
        });

        
        this.checkHovered();
        this.setupCamera();
        this.followMouseMove();
        this.createMesh();
        this.render();
    }

    get viewport(){
        let width = window.innerWidth;
        let height = window.innerHeight;
        let aspectRatio = width / height;
        let pixelRatio = window.devicePixelRatio;
        return {
            width,
            height,
            aspectRatio,
            pixelRatio,
        };
    }
    checkHovered(){
        this.inner.addEventListener("mouseenter", ()=>{
            this.hovered = true;
            this.targetAlpha = 1.0;
        });
        this.inner.addEventListener("mouseleave", ()=>{
            this.hovered = false;
            this.targetAlpha = 0.0;
            this.uniforms.uTexture.value = texture;
        });
    }
    setupCamera(){
        window.addEventListener("resize", this.onResize.bind(this));
        let fov = (180 * (2 * Math.atan(this.viewport.height / 2 / this.perspective))) / Math.PI;
    
    this.camera = new THREE.PerspectiveCamera(fov, this.viewport.aspectRatio, 0.1, 1000);
    this.camera.position.set(0, 0, this.perspective);

    // Create a renderer
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    this.renderer.setClearColor(0x000000, 0);

    this.renderer.setSize(this.viewport.width, this.viewport.height);
    this.renderer.setPixelRatio(this.viewport.pixelRatio);
    this.renderer.domElement.style.position = 'absolute';
    this.renderer.domElement.style.top = '0';
    this.renderer.domElement.style.left = '0';
    this.renderer.domElement.style.pointerEvents = 'none';
    this.renderer.domElement.style.background = 'transparent';
    this.renderer.domElement.style.zIndex = '1';
    this.container.appendChild(this.renderer.domElement);
    }
    createMesh(){
        this.geometry = new THREE.PlaneGeometry(1, 1, 20, 20);
        this.material = new THREE.ShaderMaterial({
            uniforms: this.uniforms,
            vertexShader: vertex,
            fragmentShader: fragment,
            transparent: true,
        });
        this.mesh = new THREE.Mesh(this.geometry, this.material);
        this.sizes.set(220, 280, 1);
        this.mesh.scale.set(this.sizes.x, this.sizes.y, 1);
        this.mesh.position.set(this.offset.x, this.offset.y, 0);
        this.scene.add(this.mesh);
    }
    followMouseMove(){
        window.addEventListener("mousemove", (e)=>{
            this.targetX = e.clientX;
            this.targetY = e.clientY;
        });
    }
    onResize(){
        this.camera.aspect = this.viewport.aspectRatio;
        this.camera.fov = (180 * (2 * Math.atan(this.viewport.height / 2 / this.perspective))) / Math.PI;
        this.renderer.setSize(this.viewport.width, this.viewport.height);
        this.camera.updateProjectionMatrix();
    }
    render(){
        this.offset.x = lerp(this.offset.x, this.targetX, 0.1);
        this.offset.y = lerp(this.offset.y, this.targetY, 0.1);

        this.uniforms.uOffset.value.set(
            (this.targetX-this.offset.x)*0.0003,-(this.targetY-this.offset.y)*0.0003);
        this.mesh.position.set(
            this.offset.x - window.innerWidth/2, -this.offset.y + window.innerHeight/2
        );

        this.uniforms.uAlpha.value = lerp(this.uniforms.uAlpha.value, this.targetAlpha, 0.1);

        if (DEBUG_HOVER_IMAGE && Math.abs(this.uniforms.uAlpha.value - this.targetAlpha) > 0.001) {
            console.log('hover image alpha', {
                current: this.uniforms.uAlpha.value,
                target: this.targetAlpha,
            });
        }

        this.renderer.render(this.scene, this.camera);
        window.requestAnimationFrame(this.render.bind(this));
    }
}
new shaded();
